import React, { CSSProperties, MouseEventHandler, ReactNode } from 'react';
//
import LoadingCircle from '../LoadingCircle';
//
import styles from './botao.module.css';

export type BotaoColor =
  | 'primary'
  | 'secondary'
  | 'error'
  | 'warning'
  | 'info'
  | 'success'
  | 'primary-g'
  | 'secondary-g'
  | 'error-g'
  | 'warning-g'
  | 'info-g'
  | 'success-g';

export type BotaoType = 'button' | 'submit' | 'reset' | 'url';

interface BotaoProps {
  icon?: ReactNode;
  text?: ReactNode;
  type?: BotaoType;
  onClick?: MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>;
  disabled?: boolean;
  color?: BotaoColor;
  style?: CSSProperties;
  href?: string;
  target?: string;
  loading?: boolean;
}

export default function Botao({
  icon,
  text,
  type,
  onClick,
  disabled,
  color,
  style,
  href,
  target,
  loading,
}: BotaoProps) {
  const className = styles['botao'] + ' ' + styles[color ? color : 'primary'];

  if (loading) {
    return (
      <button
        className={className}
        type="button"
        onClick={onClick as MouseEventHandler<HTMLButtonElement>}
        style={style}
        disabled
      >
        <LoadingCircle />
      </button>
    );
  }

  if (type === 'url') {
    return (
      <a
        className={className}
        href={href}
        target={target}
        style={style}
        rel="noreferrer"
        onClick={onClick as MouseEventHandler<HTMLAnchorElement>}
      >
        {icon}
        {text && <span style={icon ? { marginLeft: '0.5rem' } : {}}>{text}</span>}
      </a>
    );
  }

  return (
    <button
      className={className}
      type={type ?? 'button'}
      onClick={onClick as MouseEventHandler<HTMLButtonElement>}
      disabled={disabled}
      style={style}
    >
      {icon}
      {text && <span style={icon ? { marginLeft: '0.5rem' } : {}}>{text}</span>}
    </button>
  );
}
